export default __webpack_public_path__ + "static/media/pink.544ee17d.png";